import React from 'react';
import { Dialog } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './HandlerRegistry.module.scss';
import HandlerRegistryTabs from './HandlerRegistryTabs';
import HandlerRegistrySearch from './HandlerRegistrySearch';
import HandlerRegistryCard from './HandlerRegistryCard';
import { HandlerRegistryModalProps } from './types';

const HandlerRegistryModal: React.FC<HandlerRegistryModalProps> = ({
    isOpen,
    onClose,
    title = 'Handler Registry',
    handlers,
    categories,
    selectedCategory,
    onCategoryChange,
    searchValue,
    onSearchChange,
    onboardedHandlerIds,
    onOnboard
}) => {
    const visibleHandlers = handlers.filter((handler) => {
        const matchesCategory = selectedCategory === 'all' || handler.category === selectedCategory;
        const query = searchValue.trim().toLowerCase();
        const matchesSearch = !query
            || handler.name.toLowerCase().includes(query)
            || handler.description.toLowerCase().includes(query);
        return matchesCategory && matchesSearch;
    });

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth={false}
            PaperProps={{ className: styles.paper, elevation: 0 }}
        >
            <div className={styles.body}>
                <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Close">
                    <CloseIcon fontSize="small" />
                </button>

                <h2 className={styles.title}>{title.toUpperCase()}</h2>

                <span className={styles.badge}>{onboardedHandlerIds.length} ONBOARDED</span>

                <HandlerRegistryTabs
                    categories={categories}
                    selectedCategory={selectedCategory}
                    onCategoryChange={onCategoryChange}
                />

                <HandlerRegistrySearch value={searchValue} onChange={onSearchChange} />

                <div className={styles.cardList}>
                    {visibleHandlers.length === 0 ? (
                        <div className={styles.emptyState}>No handlers found.</div>
                    ) : (
                        visibleHandlers.map((handler) => (
                            <HandlerRegistryCard
                                key={handler.id}
                                handler={handler}
                                isOnboarded={onboardedHandlerIds.includes(handler.id)}
                                onOnboard={() => onOnboard?.(handler.id)}
                            />
                        ))
                    )}
                </div>
            </div>
        </Dialog>
    );
};

export default HandlerRegistryModal;
